<template>
  <div id="SVGpricingHero" class="svg-preloader position-relative" :class="themeCss">
    <figure v-if="hasHeader" class="position-absolute right-0 top-0 left-0"  style="margin-top: -1px;">
      <img class="js-svg-injector img-fluid" :src="headerImgSrc" alt="Image Description"
           data-parent="#SVGpricingHero">
    </figure>
    <div class="container" :class="sizeCss">
      <slot></slot>
    </div>
    <figure v-if="hasFooter" class="position-absolute right-0 bottom-0 left-0">
      <img class="js-svg-injector img-fluid" :src="footerImgSrc" alt="Image Description"
           data-parent="#SVGpricingHero">
    </figure>
  </div>
</template>

<script>
export default {
  name: "HeroSection",
  
  data() {
    return {
      themes: {
        "home/welcome": {
          css: "blue-gradient",
          footer: "wave-2-bottom-grey.svg"
        },
        "remortgage/introduction": {
        },
        "home/introduction": {
          footer: "wave-2-bottom.svg"
        },
        "home/introduction-to-remortgage": {
          header: "wave-2-top.svg",
          footer: "wave-2-bottom.svg"
        },
        "home/lenders": {
          footer: "wave-2-bottom-grey.svg"
        },
        "home/how-it-works": {
          footer: "wave-2-bottom-grey.svg"
        },
        "home/regular-alerts": {
          footer: "wave-2-bottom-blue.svg"
        },
        "home/free-mortgagewatch-alert": {
          css: "blue-gradient",
          footer: "wave-2-bottom.svg"
        },
        "blue-gradient": {
          css: "blue-gradient"
        },
        "dashboard": {
          css: "blue-gradient"
        },
        "footer": {
          header: "wave-2-top-grey.svg",
          css: "blue-gradient"
        },
      }
    }
  },
  
  computed: {
    themeCss() {
      return this.themes[this.theme] != null ? this.themes[this.theme].css : null;
    },
    
    hasFooter() {
      return this.themes[this.theme] != null && this.themes[this.theme].footer != null; 
    },
    
    hasHeader() {
      return this.themes[this.theme] != null && this.themes[this.theme].header != null;
    },
    
    headerImgSrc() {
      return this.hasHeader ? '/assets/cmc/svg/components/' + this.themes[this.theme].header : "";
    },
    footerImgSrc() {
      return this.hasFooter ? '/assets/cmc/svg/components/' + this.themes[this.theme].footer : "";
    },
    sizeCss() {
      return this.size === "sm" 
          ? "space-top-1 space-bottom-0" 
          : this.size === "lg" ? "space-top-2 space-bottom-2" : "space-sm"
    }
  },
  
  props: {
    theme: {
      type: String,
      default: "blue-gradient"
    },
    
    size: {
      type: String,
      default: "md"
    }
  }
}
</script>

<style scoped>
  div.blue-gradient {
    background-color: #377dff;
    background-image: linear-gradient(-180deg,#015acc,#377dff);
  }
  div.blue-gradient-reversed {
    background-color: #377dff;
    background-image: linear-gradient(-180deg,#377dff,#015acc);
  }
  div.grey-to-blue-gradient {
    background-color: #f7faff;
    background-image: linear-gradient(-180deg,#f7faff,#377dff);
  }
</style>